module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jfKRm"))).then(() => parcelRequire('hEqeo'));